module.exports = __webpack_public_path__ + "static/media/package.de357bcd.png";